import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

import "./Banner.css";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../../Contexts/ThemeContext";

// ✅ Desktop banners
import lgBanner1 from "../../Images/Face wash.png";
import lgBanner2 from "../../Images/shampoo-web banner.png";
import lgBanner3 from "../../Images/PerfumeBanner.jpg";
import lgBanner4 from "../../Images/hair color pc.png";
import lgBanner5 from "../../Images/Clariss new year web cover pc.png";

// ✅ Mobile banners
import mbBanner1 from "../../Images/Face wash mobile size_.png";
import mbBanner2 from "../../Images/shampoo-web banner mobile_.png";
import mbBanner3 from "../../Images/PerfumeBanner-mb.png";
import mbBanner4 from "../../Images/Hair color mb.png";
import mbBanner5 from "../../Images/Clariss new year web cover mobile.png";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const Banner = () => {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    fetch("https://clariss-backend.vercel.app/sliders")
      .then((res) => res.json())
      .then((data) => setBanners(data));
  }, []);

  const { searchText, setSearchText } = useContext(ThemeContext);
  const isDesktop = window.innerWidth > 992;

  // ✅ Responsive image selection
  const banner01 = isDesktop ? lgBanner1 : mbBanner1;
  const banner02 = isDesktop ? lgBanner2 : mbBanner2;
  const banner03 = isDesktop ? lgBanner3 : mbBanner3;
  const banner04 = isDesktop ? lgBanner4 : mbBanner4;
  const banner05 = isDesktop
    ? "https://luvit.com.bd/wp-content/uploads/2025/08/c49a9a87-8f49-4c51-853d-06243ac8ad7a-1300x338.jpg"
    : "https://luvit.com.bd/wp-content/uploads/2025/08/41b5b1aa-2a86-42d8-97a2-5775f7dced0c.jpg";

  const currentDate = dayjs().tz("Asia/Dhaka");
  const offerStartTime = dayjs.tz("2025-08-15 23:59:00", "Asia/Dhaka");
  const offerEndTime = dayjs.tz("2025-08-23 23:59:00", "Asia/Dhaka");

  const offerValidity =
    currentDate.isAfter(offerStartTime) && currentDate.isBefore(offerEndTime);

  const navigate = useNavigate();

  return (
    <div>
      {/* ✅ Semantic landmark for better SEO */}
      <section aria-label="Featured Clariss Products Banner Slider">
        <Swiper
          spaceBetween={30}
          effect={"fade"}
          navigation={window.innerWidth >= 992}
          autoplay={{
            delay: 10000,
            disableOnInteraction: false,
          }}
          pagination={
            window.innerWidth < 700 ? false : { dynamicBullets: true }
          }
          modules={[Autoplay, EffectFade, Navigation, Pagination]}
          className="mySwiper h-auto"
        >
          {/* ✅ Limited-time offer banner if active */}
          {offerValidity && (
            <SwiperSlide>
              <Link to="/shop">
                <img
                  className="w-full h-auto z-10"
                  src={banner05}
                  alt="Clariss Limited-Time New Year Offer – Shop Now"
                  width={isDesktop ? 1920 : 400}
                  height={isDesktop ? 500 : 200}
                  loading="lazy"
                />
              </Link>
            </SwiperSlide>
          )}

          {/* ✅ Hair Color Banner */}
          <SwiperSlide>
            <Link to="/product-category/hair color">
              <img
                className="w-full h-auto z-10"
                src={banner04}
                alt="Clariss Hair Color – Long-lasting vibrant shades"
                width={isDesktop ? 1920 : 400}
                height={isDesktop ? 500 : 200}
                loading="lazy"
              />
            </Link>
          </SwiperSlide>

          {/* ✅ Shampoo Banner */}
          <SwiperSlide>
            <Link to="/product-category/shampoo">
              <img
                className="w-full h-auto z-10"
                src={banner02}
                alt="Clariss Nourishing Shampoo – Natural care for healthy hair"
                width={isDesktop ? 1920 : 400}
                height={isDesktop ? 500 : 200}
                loading="lazy"
              />
            </Link>
          </SwiperSlide>

          {/* ✅ Face Wash Banner */}
          <SwiperSlide>
            <Link to="/product-category/face wash">
              <img
                className="w-full h-auto z-10"
                src={banner01}
                alt="Clariss Gentle Face Wash – Refreshing skincare for glowing skin"
                width={isDesktop ? 1920 : 400}
                height={isDesktop ? 500 : 200}
                loading="lazy"
              />
            </Link>
          </SwiperSlide>

          {/* ✅ Perfume Banner */}
          <SwiperSlide>
            <Link to="/product-category/fragrances">
              <img
                className="w-full h-auto z-10"
                src={banner03}
                alt="Clariss Fragrances – Luxurious perfumes for every occasion"
                width={isDesktop ? 1920 : 400}
                height={isDesktop ? 500 : 200}
                loading="lazy"
              />
            </Link>
          </SwiperSlide>
        </Swiper>
      </section>
    </div>
  );
};

export default Banner;
